export default "__VITE_ASSET__CsAEsSEB__"